/* eslint-disable no-extend-native */
export {};
declare global {
    interface Blob {
        toDataUrl(): Promise<string>;
        toText(): Promise<string>;
        download(name: string, type?: string | null): Promise<void>;
    }
}

if (!Blob.prototype.toDataUrl) {
    Blob.prototype.toDataUrl = function toDataUrl(this: Blob): Promise<string> {
        return new Promise<string>(async (resolve, reject) => {
            try {
                const file = new FileReader();
                file.onloadend = (result: ProgressEvent<FileReader>) => {
                    resolve(result.target.result as string);
                };
                file.onerror = e => {
                    reject(e);
                };
                file.readAsDataURL(this);
            } catch (e) {
                reject(e);
            }
        });
    };
}

if (!Blob.prototype.toText) {
    Blob.prototype.toText = function toText(this: Blob): Promise<string> {
        return new Promise<string>(async (resolve, reject) => {
            try {
                const file = new FileReader();
                file.onloadend = (result: ProgressEvent<FileReader>) => {
                    resolve(result.target.result as string);
                };
                file.onerror = e => {
                    reject(e);
                };
                file.readAsText(this);
            } catch (e) {
                reject(e);
            }
        });
    };
}

if (!Blob.prototype.download) {
    Blob.prototype.download = async function download(
        this: Blob,
        name: string,
    ): Promise<void> {
        let link = document.createElement("a");
        link.href = await this.toDataUrl();
        link.download = name;

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    };
}
